import config from "../../shared/config/config";
import axios from "../../shared/utils/axios";
import axiosNoLoading from "../../shared/utils/axiosNoLoading";
import {
  AppLoginInfoResponse,
  DriveListReqeust,
  DropboxResponse,
  FolderListResponse,
  ResponseReigstAppUrl,
} from "../../types/app";

const GATEWAY_URL = config.servers.gateway.url;
export type PRODUCT_ITEM_TYPE = "zoom" | "outlook" | "googleDrive" | "dropbox";

/**
 * 기존 wrapsody eco 2.0 에는 googleDrive와 outlook 이 있었으나,
 * 사양의 변화로 인해서 현재는 dropbox 와 zoom 만 남은 상태입니다.
 * 만약 google Drive나 outlook 이 추가된다면 wrpaosdy eco 2.0 을 참고해주세요.
 * http://git.wrapsody.fasoo.com/wrapsody-eco/wrapsody-eco-2.0
 */
export const PRODUCT_ITEM_NAME = {
  // googleDrive: "google",
  dropbox: "dropbox",
  zoom: "zoom",
} as { [type in PRODUCT_ITEM_TYPE]: string };

interface AppApi {
  getAppLoginPage(snsType: PRODUCT_ITEM_TYPE): Promise<ResponseReigstAppUrl>;
  doAppLogout(snsType: PRODUCT_ITEM_TYPE): Promise<ResponseReigstAppUrl>;
  getAppLoginInfo(snsType: PRODUCT_ITEM_TYPE): Promise<AppLoginInfoResponse>;
  getDropboxList(req: DriveListReqeust): Promise<DropboxResponse>;
  getDriveFolderList(req: {
    type: PRODUCT_ITEM_TYPE;
    folder: string;
  }): Promise<FolderListResponse>;
  uploadDropboxToEco(req: {
    fileId: string;
    uid: string;
    name: string;
    setProgressPercent?: any;
  }): Promise<any>;
  uploadEcoToDrive(req: {
    type: "google" | "dropbox";
    syncId: string;
    revisionNo: number;
    targetFolder?: string;
  }): Promise<any>;
}
class AppServerApi implements AppApi {
  async getAppLoginPage(
    snsType: PRODUCT_ITEM_TYPE
  ): Promise<ResponseReigstAppUrl> {
    const resp = await axios.get<ResponseReigstAppUrl>(
      snsType === "zoom"
        ? `${GATEWAY_URL}/wapi/${PRODUCT_ITEM_NAME[snsType]}/registUrl`
        : `${GATEWAY_URL}/wapi/oauth2/${PRODUCT_ITEM_NAME[snsType]}/registUrl`
    );
    return Promise.resolve(resp.data);
  }
  async doAppLogout(snsType: PRODUCT_ITEM_TYPE): Promise<ResponseReigstAppUrl> {
    const resp =
      snsType === "zoom"
        ? await axios.post<ResponseReigstAppUrl>(
            `${GATEWAY_URL}/wapi/${PRODUCT_ITEM_NAME[snsType]}/unregist`
          )
        : await axios.get<ResponseReigstAppUrl>(
            `${GATEWAY_URL}/wapi/oauth2/${PRODUCT_ITEM_NAME[snsType]}/revoke`
          );

    return Promise.resolve(resp.data);
  }
  async getAppLoginInfo(
    snsType: PRODUCT_ITEM_TYPE
  ): Promise<AppLoginInfoResponse> {
    const resp = await axios.get<AppLoginInfoResponse>(
      snsType === "zoom"
        ? `${GATEWAY_URL}/wapi/${PRODUCT_ITEM_NAME[snsType]}/myInfo`
        : `${GATEWAY_URL}/wapi/oauth2/${PRODUCT_ITEM_NAME[snsType]}/info`
    );
    return Promise.resolve(resp.data);
  }
  async getDropboxList(req: DriveListReqeust): Promise<DropboxResponse> {
    delete req["isRefresh"];

    const resp = await axios.post<DropboxResponse>(
      `${GATEWAY_URL}/wapi/oauth2/dropbox/files`,
      {
        ...req,
        pageSize: 30,
      }
    );
    return Promise.resolve(resp.data);
  }
  async getDriveFolderList(req: {
    type: PRODUCT_ITEM_TYPE;
    folder: string;
  }): Promise<FolderListResponse> {
    const resp = await axios.post<FolderListResponse>(
      `${GATEWAY_URL}/wapi/oauth2/${
        req.type === "googleDrive" ? "google" : "dropbox"
      }/folders`,
      {
        folder: req.folder,
      }
    );
    return Promise.resolve(resp.data);
  }
  async uploadDropboxToEco(req: {
    fileId: string;
    uid: string;
    name: string;
    setProgressPercent?: any;
  }): Promise<any> {
    const resp = await axiosNoLoading.get<any>(
      `${GATEWAY_URL}/wapi/oauth2/dropbox/files/${req.fileId}/download/${req.uid}?fileName=${req.name}`
    );
    return Promise.resolve(resp.data);
  }
  async uploadEcoToDrive(req: {
    type: "google" | "dropbox";
    syncId: string;
    revisionNo: number;
    targetFolder?: string;
  }): Promise<any> {
    const resp = await axiosNoLoading.get<any>(
      req.targetFolder !== "root" && req.targetFolder !== "/"
        ? `${GATEWAY_URL}/wapi/oauth2/${req.type}/files/upload/${req.syncId}/revisions/${req.revisionNo}?targetFolder=${req.targetFolder}`
        : `${GATEWAY_URL}/wapi/oauth2/${req.type}/files/upload/${req.syncId}/revisions/${req.revisionNo}`
    );
    return Promise.resolve(resp.data);
  }
}

const appApi: AppApi = new AppServerApi();
export default appApi;
